// ##### Komarov 2025-09-03: Middleware to build pages object right after pages are fetched
import { GET_PAGES_RES, SET_PAGES_REDUX } from '../../constants';
import { getPagesToRedux } from '../../../helpers/messages';

export const pagesReduxMiddleware = store => next => action => {
  if (action && action.type === GET_PAGES_RES) {
    const state = store.getState();
    const language = state.language;
    const pages = action.payload || [];

    const pagesObj = getPagesToRedux({ pages, language });

    // Write computed pagesObj into redux
    store.dispatch({ type: SET_PAGES_REDUX, payload: { ...pagesObj, language } });
  }

  return next(action);
};
